$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  let order = $("body").attr("order") || null;
  const confirmation_code = $("body").attr("confirmation_code");

  if (p === "order_confirmation") {
    connectWebSocket();

    if ($("body").attr("is_verifone") !== "1") {
      checkTerminalAvailability("return_order");
    }
    initDisabledTooltips();
    const shopType = new URLSearchParams(window.location.search).get(
      "shop_type",
    );
    let isPOS = shopType && shopType !== "take-away";

    const routeToPOS = $("#route-to-pos").attr("href");

    if (isPOS && !order) {
      setTimeout(function () {
        document.location.href = routeToPOS;
      }, 10000);
    }

    $(document).on("click", "#complete-payment", function () {
      const payload = {
        confirmation_code,
      };

      getPaymentSplitModal(payload, "#order-confirmation-footer");
    });
  }
});
